import { client } from './client';

export const addonSignup = ({
  firstName,
  lastName,
  electricityAccountNumber,
  email,
  phoneNumber,
  address,
  postcode,
  topic
}) =>
  client('heatpump-signup', {
    method: 'POST',
    body: {
      topic,
      channel: 'nep',
      emailAddress: email,
      additionalInformation: {
        name: `${firstName} ${lastName}`,
        accountNumber: electricityAccountNumber,
        phoneNumber,
        address,
        postcode
      }
    }
  });
